import { render, staticRenderFns } from "./Instrutores.vue?vue&type=template&id=020a77ea&scoped=true"
import script from "./Instrutores.vue?vue&type=script&lang=js"
export * from "./Instrutores.vue?vue&type=script&lang=js"
import style0 from "./Instrutores.vue?vue&type=style&index=0&id=020a77ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a77ea",
  null
  
)

export default component.exports